import React, { useMemo, useState } from 'react';

// createRef, useEffect,
import { Divider, List, ListItem } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SkeletonLoader from 'components/SkeletonLoader';
import styled, { css } from 'styled-components';
import {
  HideScrollbarCSS,
  StyledButton,
  // StyledDivider,
  StyledTypography,
} from 'styles/common';

import { StyledIcon } from 'constants/icons';
import theme from 'constants/theme';

// It's not a generic component
// Specifically designed for cohort creation

const ClickToSetVerticalNavBar = ({
  sectionList = [], // Array of type { id, header, componenet}
  loading = false,
  showDividers = false,
  className,
  defaultSelectedIndex = 0, // index of default selected when renders
}) => {
  const [selectedNav, setSelectedNav] = useState(sectionList.length > 0 ? sectionList[defaultSelectedIndex].id : '');

  const selectedSection = useMemo(() => sectionList.find(({ id }) => id === selectedNav), [selectedNav, sectionList]);

  return (
    <>
      {loading ? (
        <SkeletonLoader skeletons={['95%', '95%', '95%', '95%']} />
      ) : (
        <>
          {' '}
          <Divider />
          <StyledContainer className={className}>
            <StyledList>
              {sectionList.map(({ id, header }, index) => (
                <StyledListItemWrapper
                  key={id}
                  isSelected={id === selectedNav}
                  handleOnClick={() => {
                    setSelectedNav(id);
                  }}
                >
                  <StyledTypography
                    color={id === selectedNav ? theme.palette.text.primaryBlue : theme.palette.text.label}
                    cursor="pointer"
                    style={{ padding: '1.125rem 1.25rem', flex: '1' }}
                  >
                    {header(id === selectedNav)}
                  </StyledTypography>
                </StyledListItemWrapper>
              ))}
            </StyledList>
            <ScrollableContainer>{selectedSection && <div>{selectedSection.component()}</div>}</ScrollableContainer>
          </StyledContainer>
        </>
      )}
    </>
  );
};

const StyledListItemWrapper = ({ children, isSelected = false, handleOnClick }) => (
  <StyledListItem
    disableFocusRipple
    disableRipple
    onClick={handleOnClick}
    selected={isSelected}
    divider
    style={{ padding: 0 }}
  >
    {children}

    <StyledIcon
      color={isSelected ? theme.palette.text.primaryBlue : theme.palette.icons.grey2}
      style={{ marginRight: '0.5rem' }}
    >
      <ChevronRightIcon />
    </StyledIcon>
  </StyledListItem>
);

const StyledListItem = styled(ListItem)`
  &.Mui-selected {
    background-color: ${theme.palette.background.paper};
  }
  &.Mui-selected:hover {
    background-color: ${theme.palette.background.paper};
  }
  padding-left: 1.25rem;
`;

const ScrollableContainer = styled.div`
  position: relative;
  overflow-y: auto;
  ${HideScrollbarCSS};
  padding: 0rem 1rem;
  width: 100%;
`;

const StyledList = styled(List)`
  background-color: ${theme.palette.background.lightGrey4};
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
  padding: 0;
  overflow-y: auto;
  ${HideScrollbarCSS}
`;

const NavigationBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 1rem;
  border-bottom: 1px solid lightgrey;
`;

const StyledContainer = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  overflow: hidden;
  margin: 0;
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: 0.3;
  `};
`;

const blueBorderCSS = css`
  border-bottom: 3px solid ${(props) => props.theme.palette.primary.main};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

const StyledNavButton = styled(StyledButton)`
  border-bottom: 3px solid transparent;
  ${(props) => props.selected && blueBorderCSS};
`;

export default ClickToSetVerticalNavBar;
